<template>
  <div
    v-if="showPilotTooltip"
    class="pilot-tooltip"
    :style="{left: `${pilotTooltipOffset.x}px`, top: `${pilotTooltipOffset.y}px`}"
  >
    <div class="pilot-tooltip__title">
      {{ $t('pilotTooltipTitle') }}
    </div>
    <button
      class="pilot-tooltip__confirm-btn"
      @click="onConfirm"
    >
      <div>{{ $t('pilotTooltipConfirm') }}</div>
      <div class="ripple-loader">
        <div class="ripple-loader__ripple1" />
        <div class="ripple-loader__ripple2" />
        <div class="ripple-loader__ripple3" />
      </div>
    </button>
    <button
      class="pilot-tooltip__cancel-btn"
      @click="onCancel"
    >
      {{ $t('pilotTooltipCancel') }}
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PilotTootip',
  computed: {
    ...mapGetters(['pilotList', 'isPilotTooltipActive', 'pilotTooltipOffset', 'isFloatMenuActive', 'isMobileMenuActive']),
    showPilotTooltip () {
      return this.pilotList.length > 0 && (this.isFloatMenuActive || this.isMobileMenuActive) && this.isPilotTooltipActive
    }
  },
  methods: {
    ...mapActions([
      'changeShownPilotTooltipState',
      'closePilotTooltip',
      'closeMobileMenu'
    ]),
    onConfirm () {
      this.closeMobileMenu()
      this.closePilotTooltip()
      this.$emit('confirm')
      this.changeShownPilotTooltipState(true)
    },
    onCancel () {
      this.closeMobileMenu()
      this.closePilotTooltip()
      this.changeShownPilotTooltipState(true)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'

@media (max-width:1024px) and (min-width:560px) {
  .pilot-tooltip{
    transform: translate(-100%, -50%) !important;
    max-width: 165px;
  }
}
@media (max-width:1024px){
  .pilot-tooltip::before {
    content: ''
    position: absolute
    top: 50%
    right: 100%
    margin-top: -5px
    border-width: 5px
    border-style: solid
    border-color: transparent alpha($dark-gray, 80%) transparent transparent
  }
}

@media (min-width:1024px){
  .pilot-tooltip::after {
    content: ''
    position: absolute
    top: 50%
    left: 100%
    margin-top: -5px
    border-width: 5px
    border-style: solid
    border-color: transparent transparent transparent alpha($dark-gray, 80%)
  }
}

.pilot-tooltip {
  text-align: center;
  position: fixed
  min-width: 165px
  padding: 16px
  z-index 99
  transform: translate(-100%, -50%)
  background-color: alpha($dark-gray, 80%)
  border-radius: 8px
  pointer-events: auto /* Because global css pollution lead to can not click by mouse */

  &__title {
    font-family: 'Noto Sans TC', 'Arial'
    font-size: 14px
    font-weight: 400
    line-height: 20.27px
    color: $white
    word-break: break-word
  }

  &__confirm-btn {
    margin-top: 15px
    position relative
    font-family: 'Noto Sans TC', 'Arial'
    font-size: 12px
    font-weight: 700
    color: $white
    width: 100%
    background-color: $default-pink
    border-radius: 8px
    padding: 6px
    cursor: pointer

    &:hover {
      background-color: $hover-pink
    }
  }

  &__cancel-btn {
    margin-top: 15px
    font-family: 'Noto Sans TC', 'Arial'
    width: 100%
    background-color: transparent
    color: $white
    text-decoration: underline
    font-weight: 400
    font-size: 12px
    line-height: 17px
    cursor: pointer
  }
}

.ripple-loader {
  position: absolute
  top: 0
  right: 20%

  ripple($animation_name) {
    position: absolute
    width: 48px
    height: 48px
    background-color: transparent
    border: 4px solid $white
    border-radius: 50%
    animation: 1.8s $animation_name .3s ease-in-out infinite
  }

  &__ripple1 {
    ripple(ripple1)
  }

  &__ripple2 {
    ripple(ripple2)
  }

  &__ripple3 {
    ripple(ripple3)
  }

  @keyframes ripple1 {
    0% {
      opacity: 0
      transform: scale(.0625)
    }

    50% {
      opacity: 1
      transform: scale(.5)
    }

    100% {
      opacity: 0
      transform: scale(1)
    }
  }

  @keyframes ripple2 {
    0% {
      opacity: 1
      transform: scale(.5)
    }

    50% {
      opacity: 0
      transform: scale(1)
    }

    100% {
      opacity: 0
      transform: scale(.0625)
    }
  }

  @keyframes ripple3 {
    0% {
      opacity: 0
      transform: scale(1)
    }

    50% {
      opacity: 0
      transform: scale(.0625)
    }

    100% {
      opacity: 1
      transform: scale(.5)
    }
  }
}
</style>
